import { useCallback, useState } from "react";

/**
 * Diferente de `useSessionStorage` (que, apesar do nome, usa `localStorage`),
 * este hook usa o `sessionStorage` real do navegador — o valor não sobrevive
 * ao fechamento da aba/janela, só à navegação entre páginas da mesma sessão.
 */
export function useBrowserSessionStorage(key: string, initialValue = "") {
  const [state, setState] = useState(() => {
    try {
      const storageValue = sessionStorage.getItem(key);
      return storageValue ? JSON.parse(storageValue) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = useCallback(
    (value: string) => {
      try {
        setState(value);
        sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.log(error);
      }
    },
    [key],
  );

  const removeValue = useCallback(() => {
    try {
      setState(initialValue);
      sessionStorage.removeItem(key);
    } catch (error) {
      console.log(error);
    }
  }, [key, initialValue]);

  return [state, setValue, removeValue] as const;
}
